import styled from "styled-components";
import Block, { BlockContent, BlockGrid } from "~/components/Block";
import Card from "~/components/Card";
import { ResellerDocument } from "~/external/v2/types";
import theme from "~/styles/theme";

// TODO: Extends getCommonSliceProps
type ResellerSelectionProps = {
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  highlightColor?: string;
  color?: string;
  animateIn?: boolean;

  columnsOnMobile: number;
  columnsOnDesktop: number;

  resellers: ResellerDocument[];
  merged: { resellers: ResellerDocument[] };
};

const variants = {
  out: { opacity: 0, y: "100%" },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      type: "tween",
      ease: [0.23, 1, 0.32, 1],
      duration: 2,
    },
  },
};

const ResellerCardTitle = styled.h3<any>`
  margin: 0;
`;

const ResellerCardContent = styled.div<any>`
  margin-top: 0.8rem;
`;

function ResellerCardContentWebsite(props: any) {
  const { website } = props;

  if (!website) return null;

  return (
    <div>
      <img
        src="/static/assets/icons/Globe-30@3x.png"
        alt="Globe icon"
        style={{
          width: "15px",
          display: "inline-block",
          lineHeight: "1em",
        }}
      />{" "}
      <a
        href={website.url}
        target="_blank"
        rel="noopener nofollow noreferrer"
        style={{
          color: theme.colors.dark,
          display: "inline-block",
          lineHeight: "1em",
          top: "-3px",
          position: "relative",
          marginLeft: "6px",
        }}
      >
        {new URL(website.url).hostname.replace("www.", "")}
      </a>
    </div>
  );
}

function ResellerCardContentLocations(props: any) {
  const { locations } = props;

  if (!locations || locations.length == 0) return null;

  return (
    <div>
      <img
        src="/static/assets/icons/Maps-30@3x.png"
        alt="Maps icon"
        style={{
          width: "15px",
          display: "inline-block",
          lineHeight: "1em",
        }}
      />{" "}
      <span
        style={{
          lineHeight: "1em",
          top: "-1px",
          position: "relative",
          marginLeft: "6px",
        }}
      >
        {locations.length} store {locations.length > 1 ? "locations" : "location"}
      </span>
    </div>
  );
}

function ResellerCard(props: any) {
  const { reseller, layout } = props;
  return (
    <Card
      color={layout.color}
      showProductPrice={false}
      type="a"
      allClickable
      buttonSpacing={4}
      media={
        reseller.content.logo &&
        reseller.content.logo.url && [
          reseller.content.logo.url,
          "image",
          reseller.content.logo.dimensions.width,
          reseller.content.logo.dimensions.height,
          reseller.content.logo.alt,
        ]
      }
      href={reseller.content.website.url}
      hrefAs={reseller.content.website.url}
      hrefTarget="_blank"
      title={
        <ResellerCardTitle>
          {reseller.content.name
            .map((item) => item.text)
            .filter((text) => !!text)
            .join(" ")}
        </ResellerCardTitle>
      } // {getRichText(reseller.content.name)} // TODO: Make flat (key text)?
      text={
        <ResellerCardContent>
          <ResellerCardContentWebsite website={reseller.content.website} />
          <ResellerCardContentLocations locations={reseller.content.locations} />
        </ResellerCardContent>
      }
      // {...reseller}
    />
  );
}

function renderResellers(layout: any, resellers: ResellerDocument[]) {
  return (
    <Block
      spacingTop={layout.spacingTop}
      spacingBottom={layout.spacingBottom}
      backgroundColor={layout.backgroundColor}
      color={layout.color}
    >
      <BlockContent>
        <BlockGrid
          columnsOnMobile={layout.columnsOnMobile}
          cols={layout.columnsOnDesktop}
        >
          {resellers.map((reseller) => (
            <ResellerCard key={reseller.id} layout={layout} reseller={reseller} />
          ))}
        </BlockGrid>
      </BlockContent>
    </Block>
  );
}

export default function ResellerSelection(props: ResellerSelectionProps) {
  const {
    // NOTE: NOT MAPPED FROM SLICE YET -- BEGIN
    spacingTop = 0,
    spacingBottom = 6,
    highlightColor,
    color,
    backgroundColor,
    animateIn = false,
    // NOTE: NOT MAPPED FROM SLICE YET -- END

    columnsOnMobile = 2,
    columnsOnDesktop = 4,

    resellers = [],
    merged = { resellers: [] },
  } = props;

  // console.log('MERGED', merged);

  return (
    <>
      {renderResellers(
        {
          spacingTop,
          spacingBottom,
          backgroundColor,
          highlightColor,
          color,
          animateIn,
          columnsOnDesktop,
          columnsOnMobile,
        },
        resellers
      )}
    </>
  );
}
